import { ArrayInput, SimpleFormIterator, SimpleForm, Button, useNotify, useRefresh, SaveButton } from "react-admin";
import { Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import EmployeeOrExternalFields from "./EmployeeOrExternalFields";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import { useNotifyError } from "utils/useNotifyError";

const ProfessorsEditForm = ({ record, setIsEditing }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();
  const notifyError = useNotifyError();

  const handleSave = async data => {
    try {
      await dataProvider.customRequest(
        specialistRequests.updateAdvancedSpecializationProfessors(record.id),
        { professors: data.professors },
        "PUT",
      );
      notify("Преподавателите са обновени успешно", { type: "success" });
      setIsEditing(false);
      refresh();
    } catch (err) {
      notifyError(err);
      handleConflictError(err);
    }
  };

  return (
    <>
      <SimpleForm
        toolbar={false}
        onSubmit={handleSave}
        // Empty array from the record keeps this single empty row (lodash merge)
        defaultValues={{ professors: [{}] }}
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <ArrayInput
              source="professors"
              label=""
              fullWidth
            >
              <SimpleFormIterator
                inline
                fullWidth
              >
                <EmployeeOrExternalFields
                  professorLabel="Преподавател"
                  source="professors"
                  fullWidth
                />
              </SimpleFormIterator>
            </ArrayInput>
          </Grid>
        </Grid>
        <Grid sx={{ display: "flex", gap: 3, mt: 3 }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={() => setIsEditing(false)}
          />
          <SaveButton
            label="Запази"
            size="small"
            alwaysEnable
          />
        </Grid>
      </SimpleForm>
      <ConflictErrorDialog />
    </>
  );
};

export default ProfessorsEditForm;
